import axios from 'axios';

const baseUrl = window.location.origin.includes('localhost')
    ? 'http://localhost:8000/api/'
    : (process.env.VUE_APP_API_URL || 'https://bitacorapp2.com/api/')

const instance = axios.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default instance;